// extracted by mini-css-extract-plugin
module.exports = {"modal":"index_modal_36I46","body":"index_body_2u9Qn"};